import React from 'react';

const CallSummary = () => {
  return <div>CallSummary</div>;
};

export default CallSummary;
